import React from 'react';
import { render } from '@testing-library/react';
import { Modal } from './Modal';
import { BodyText } from '../BodyText';

describe('Modal', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Modal
				open
				title="Modal Title"
				closable
				scrollable
				data-auto-sel="automation-selector"
			>
				<BodyText className="m-b-2">Lorem ipsum etsy pabst</BodyText>
			</Modal>
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       Drawer is rendered in a portal
		 */
		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
